export function isDescendant(
  parent: Element | null,
  child: Element | null
): boolean {
  const getParentNode = (node: Element): Element => {
    const parentNode = node.parentNode as Element & ShadowRoot;

    return parentNode?.nodeType === Node.DOCUMENT_FRAGMENT_NODE
      ? parentNode?.host
      : parentNode;
  };

  if (!parent || !child) {
    return false;
  }

  let node = getParentNode(child);

  while (node != null) {
    if (node == parent) {
      return true;
    }

    node = getParentNode(node);
  }
  return false;
}
